// Middleware component for React application
import React, { useCallback, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

const Middleware = ({
	children,
	requiredRoles = ["admin", "teacher", "student"],
	additionalCriteria,
}) => {
	const navigate = useNavigate();
	const { user, loading } = useContext(AuthContext);

	// Mock function to validate additional criteria; replace with actual logic
	const isCriteriaMet = useCallback(async () => {
		return additionalCriteria ? await additionalCriteria() : true;
	}, [additionalCriteria]);

	useEffect(() => {
		if (!loading) {
			const checkValidity = async () => {
				const criteriaMet = await isCriteriaMet();
				if (!requiredRoles.includes(user?.role) || !criteriaMet) {
					navigate("/unauthorized"); // Redirect to unauthorized page if criteria fails
				}
			};
			checkValidity();
		}
	}, [user, loading, isCriteriaMet, requiredRoles, navigate]);

	return <>{children}</>; // Render children if validation passes
};

export default Middleware;
